module.exports = __webpack_public_path__ + "img/sy.a971c2a0.svg";